import Vue from "vue";
import VueRouter from "vue-router";
import activityBills from "../views/activityBills.vue";
import baojia from "../views/baoJia.vue";
import historicalOrders from "../views/historicalOrders.vue";
import orderDetail from "../views/orderDetail.vue";

import myAddress from "../views/myAddress.vue";
import addAddress from "../views/addAddress.vue";
import buyCarNew from "../views/buyCarNew.vue";
import firmOrder from "../views/firmOrder.vue";
import vinHistory from "../views/vinHistory.vue";
import paySuccess from '../views/paySuccess.vue'
import payFail from '../views/payFail.vue'
import errorCorrection from '../views/errorCorrection.vue'
import errorCorrectionHistory from '../views/errorCorrectionHistory.vue'
import selectCustomer from '../views/selectCustomer.vue'
import goodsSearch from "../views/goodsSearch.vue";
import chatRoom from "../views/vinSearch.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "activityBills",
    component: activityBills,
    meta: {
      title: "报价单",
    },
  },
  {
    path: "/baojia",
    name: "baojia",
    component: baojia,
    meta: {
      title: "报价单",
    },
  },
  {
    path: "/historicalOrders",
    name: "historicalOrders",
    component: historicalOrders,
    meta: {
      title: "历史订单",
    },
  },
  {
    path: "/orderDetail/:id",
    name: "orderDetail",
    component: orderDetail,
    meta: {
      title: "历史订单",
    },
  },
  {
    path: "/vinHistory",
    name: "vinHistory",
    component: vinHistory,
    meta: {
      title: "历史查询",
    },
  },
  {
    path: "/buyCar",
    name: "buyCar",
    component: buyCarNew,
    meta: {
      title: "购物车",
    },
  },
  {
    path: "/firmOrder",
    name: "firmOrder",
    component: firmOrder,
    meta: {
      title: "确认订单",
    },
  },
  {
    path: "/myAddress",
    name: "myAddress",
    component: myAddress,
    meta: {
      title: "我的地址",
    },
  },
  {
    path: "/addAddress",
    name: "addAddress",
    component: addAddress,
    meta: {
      title: "添加地址",
    },
  },
  {
    path: '/paySuccess',
    name: 'paySuccess',
    component: paySuccess,
    meta: {
      title:'支付成功',
    }
  },
  {
    path: '/payFail',
    name: 'payFail',
    component: payFail,
    meta: {
      title:'支付失败',
    }
  },
  {
    path: '/errorCorrection',
    name: 'errorCorrection',
    component: errorCorrection,
    meta: {
      title:'产品纠错',
    }
  },
  {
    path: '/errorCorrectionHistory',
    name: 'errorCorrectionHistory',
    component: errorCorrectionHistory,
    meta: {
      title:'历史纠错',
    }
  },
  {
    path: '/selectCustomer',
    name: 'selectCustomer',
    component: selectCustomer,
    meta: {
      title:'选择客户',
    }
  },
  {
    path: '/goodsSearch',
    name: 'goodsSearch',
    component: goodsSearch,
    meta: {
      title:'商品搜索',
    }
  },
  {
    path: '/vinSearch',
    name: 'vinSearch',
    component: chatRoom,
    meta: {
      title:'重新适配',
    }
  }
  
];

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
